import { Pipe, PipeTransform } from '@angular/core';
import { FormatDateService } from '../service/format-date.service';

@Pipe({
  name: 'formatDate'
})
export class FormatDatePipe implements PipeTransform {

  constructor(private formatDateService: FormatDateService) {
  }

  transform(value: any, ...args: any[]): any {
    if (!value) {
      return '';
    }
    return this.formatDateService.format(value, args[0], args.length > 1 ? args[1] : null);
  }
}
